var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 9.00781C7.97135 9.0026 8.16667 8.96094 8.34375 8.88281C8.52083 8.79948 8.69531 8.67188 8.86719 8.5L14.2578 2.99219C14.5078 2.73698 14.6328 2.43229 14.6328 2.07812C14.6328 1.82812 14.5729 1.60156 14.4531 1.39844C14.3333 1.19531 14.1719 1.03385 13.9688 0.914062C13.7708 0.789062 13.5495 0.726562 13.3047 0.726562C12.9349 0.726562 12.6068 0.872396 12.3203 1.16406L7.49219 6.17188H8.04688L3.19531 1.16406C2.90885 0.872396 2.58073 0.726562 2.21094 0.726562C1.96615 0.726562 1.74219 0.789062 1.53906 0.914062C1.34115 1.03385 1.18229 1.19531 1.0625 1.39844C0.942708 1.60156 0.882812 1.82812 0.882812 2.07812C0.882812 2.25521 0.914062 2.41927 0.976562 2.57031C1.03906 2.72135 1.13281 2.86198 1.25781 2.99219L6.65625 8.5C6.98958 8.83854 7.35677 9.00781 7.75781 9.00781Z",
    fill: "#9c85f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.12d8b4944d8e8ddaaa55556a7d92e332.svg";
export { ForwardRef as ReactComponent };